import { pushToDataLayer } from './pushToDataLayer';

export const enum DataLayerPdpEvent {
  pdp_cta_interaction = 'pdp_cta_interaction',
  pdp_gallery_interaction = 'pdp_gallery_interaction',
  pdp_imperfections_interaction = 'pdp_imperfections_interaction',
  pdp_service_history_interaction = 'pdp_service_history_interaction',
}

export type DataLayerPdpPayload = {
  option: Option;
  sku: string | null;
};
type Option =
  | 'PRICE_GUIDE'
  | 'OPEN_DOOR'
  | 'CLOSE_DOOR'
  | 'EXPAND'
  | 'INTERIOR'
  | 'GALLERY'
  | 'IMPERFECTIONS'
  | 'CHAT_OPEN'
  | 'CHAT_CLOSE'
  | 'VIEW_360'
  | 'EXTERIOR'
  | 'NEXT'
  | 'PREVIOUS'
  | 'SPIN'
  | undefined;

export const pushToDataLayerPDP = (event: DataLayerPdpEvent, data?: Partial<DataLayerPdpPayload>) => {
  const width = window.innerWidth;
  pushToDataLayer({
    event,
    value: {
      ...data,
      device: width < 550 ? 'mobile' : 'desktop',
      date: new Date().toISOString(),
    },
  });
};
